import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import {
  dbio
} from './plugins/axios';
import {
  msg
} from './plugins/common';
import router from './router'
import * as filters from './filter'; // global filters

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    dbio,
    msg
  }
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    // 禁止直接訪問
    switch (to.name) {
      case 'ReservedList':
        if (from.name !== 'ReservedIndex') {
          next({
            path: '/'
          })
        }
        break;
    }
    next()
  } else next()

})

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')